import { render, staticRenderFns } from "./PlanManage.vue?vue&type=template&id=4996e37a"
import script from "./PlanManage.vue?vue&type=script&lang=js"
export * from "./PlanManage.vue?vue&type=script&lang=js"
import style0 from "./PlanManage.vue?vue&type=style&index=0&id=4996e37a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports